import api from './api';

// Huoltokirjaukset (#82, .claude/maarittelyt/82-huoltokirjaukset.md, versio 5).
// Jokainen kirjaus on tapahtuma, jonka id luodaan täällä: sama kirjaus voidaan
// lähettää uudelleen ilman tuplia. Vaiheessa B sama muoto kulkee offline-jonon kautta.

export const STATUSES = ['ok', 'not'];
export const EXPIRY_WARNING_DAYS = 60;

export const STATUS_STYLE = {
  ok: 'bg-green-100 text-green-800',
  not: 'bg-red-100 text-red-800',
};

export function newId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  // Vanhat selaimet: RFC 4122 v4 getRandomValuesilla
  const b = window.crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map(x => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

// Vaiheen A kategoria näytetään vain vanhoilla riveillä (versio 5: tarvike = nimi, kategoria 'other').
export function categoryLabel(item, t) {
  if (item.category === 'other') return '';
  return item.category === 'custom' ? item.custom_category : t(`service.category.${item.category}`);
}

// Tarvikkeen sarakeavain: sama nimi kirjainkoosta ja välilyönneistä riippumatta (päätös 32).
export const itemKey = name => String(name || '').trim().toLowerCase();

// Vanhenemispäivä on kuukauden tarkkuudella (päätös 11): kannassa kuukauden 1. päivä.
// 'YYYY-MM-DD…' → 'YYYY-MM' (input type="month").
export function toMonthInput(value) {
  return value ? String(value).slice(0, 7) : '';
}

// 'YYYY-MM-DD…' → 'MM/YYYY'
export function formatMonth(value) {
  if (!value) return '';
  const [y, m] = String(value).slice(0, 7).split('-');
  return `${m}/${y}`;
}

// 'expired' | 'soon' | null. Kuluva kuukausi on vielä voimassa.
export function expiryState(expiresOn) {
  if (!expiresOn) return null;
  const [y, m] = String(expiresOn).slice(0, 7).split('-').map(Number);
  const now = new Date();
  const monthIndex = y * 12 + (m - 1);
  const nowIndex = now.getFullYear() * 12 + now.getMonth();
  if (monthIndex < nowIndex) return 'expired';
  const start = new Date(y, m - 1, 1);
  if ((start - now) / 86400000 <= EXPIRY_WARNING_DAYS) return 'soon';
  return null;
}

export const EXPIRY_STYLE = {
  expired: 'text-red-600 font-medium',
  soon: 'text-amber-600 font-medium',
};

// Lähettää yhden tai useamman kirjauksen. Palauttaa palvelimen tulokset; heittää
// virheen, jos jokin kirjaus hylättiin (syy err.reasons).
export async function sendEntries(entries, performedBy) {
  const now = new Date().toISOString();
  const body = {
    entries: entries.map(e => ({
      ...e,
      performed_at: e.performed_at || now,
      performed_by: performedBy,
    })),
  };
  const { data } = await api.post('/api/service/entries', body);
  const rejected = data.results.filter(r => r.status === 'rejected');
  if (rejected.length) {
    const err = new Error('rejected');
    err.reasons = rejected.map(r => r.reason);
    throw err;
  }
  return data.results;
}

export function errorText(err, t) {
  if (err.reasons) return err.reasons.map(r => t(`service.reason.${r}`, r)).join(', ');
  return err.response?.data?.error || t('common.saveFailed');
}
